import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FourOhFour = (): null => {
    const navigate = useNavigate();
    useEffect(() => {
        navigate(`/`);
    }, []);
    return null;
};

export default FourOhFour;
